import PropTypes from 'prop-types';
import styled from 'styled-components';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import UIExpandableSection from 'UIComponents/accordion/UIExpandableSection';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledExpandableSection = styled(UIExpandableSection).withConfig({
  displayName: "FieldGroup__StyledExpandableSection",
  componentId: "sc-184m29j-0"
})(["&:first-of-type > div{border-top:0 !important;}"]);
const FieldGroup = ({
  children,
  defaultOpen,
  expandable,
  headerSecondaryContent,
  label
}) => {
  if (expandable) {
    return /*#__PURE__*/_jsx(StyledExpandableSection, {
      defaultOpen: defaultOpen,
      titleText: label,
      indentation: "none",
      children: children
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(MediaObject, {
      align: "baseline",
      itemRight: headerSecondaryContent,
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: label && /*#__PURE__*/_jsx("h5", {
          children: /*#__PURE__*/_jsx(View, {
            marginInlineEnd: "100",
            as: "span",
            children: label
          })
        })
      })
    }), children]
  });
};
FieldGroup.propTypes = {
  children: PropTypes.node.isRequired,
  defaultOpen: PropTypes.bool,
  expandable: PropTypes.bool,
  headerSecondaryContent: PropTypes.node,
  label: PropTypes.string
};
export default FieldGroup;